import React from "react";
import { Alert } from "react-bootstrap";

interface UserStatusAlertProps {
    variant: string;
    message: string;
    onClose: () => void;
}

export const UserStatusAlert: React.FC<UserStatusAlertProps> = ({
    variant,
    message,
    onClose
}) => {
    if (!message) return null;

    return (
        <Alert
            variant={variant}
            onClose={onClose}
            dismissible
        >
            {message}
        </Alert>
    );
};
